import React from "react";

const BtnLoader = (props) => {
  return (
    <span className="btn_loader">
      <span className="spinner-border text-light spinner-border-sm" role="status" aria-hidden="true"></span>
      {props && props.name ? props.name : 'Loading'}...
    </span>
  );
};

export default BtnLoader;